const lodashMerge = require('lodash/merge');
const defaultConfig = require('./environments/default');

const env = process.env.TYC_ENV;
const getEnvConfig = () => {
  switch (env) {
    case 'development':
      return require('./environments/development');

    case 'test':
      return require('./environments/test');

    case 'pre':
      return require('./environments/pre');

    case 'production':
    default:
      return require('./environments/production');
  }
};

const runtimeConfig = lodashMerge(defaultConfig, getEnvConfig(), { env });

module.exports = runtimeConfig;
